import type { ResourceProps } from 'react-admin';
import portaitIcon from '@mui/icons-material/Portrait';
import { type ComponentType, lazy } from 'react';

const AsyncPageList = lazy(() => import('./list'));
const AsyncPageShow = lazy(() => import('./show'));

const protectedList = () => (
  // <CanAccess resource={resources.policies} action="list">
  <AsyncPageList />
  // </CanAccess>
);

export default {
  list: protectedList as ComponentType<any>,
  show: AsyncPageShow as ComponentType<any>,
  icon: portaitIcon as ComponentType<any>,
} as ResourceProps;
